import {
  pipe,
  cond,
  always,
  equals,
  gte,
  not,
  isNil,
  isEmpty,
  defaultTo,
  length,
  either
} from 'ramda'

const validateDm = cond([
  [
    pipe(defaultTo(''), length, gte(10000), not),
    always('Message cannot contain more than 10 000 characters')
  ],
  [either(isNil, isEmpty), always('Message cannot be empty')]
])

const validateTweet = cond([
  [
    window.twttr.txt.isInvalidTweet,
    pipe(
      window.twttr.txt.isInvalidTweet,
      cond([
        [
          equals('too_long'),
          always('Message cannot contain more than 1000 characters')
        ],
        [equals('empty'), always('Message cannot be empty')]
      ])
    )
  ]
])

const prependChars = text => '@' + '0'.repeat(15) + ' ' + text

const validateBlastTweet = pipe(prependChars, validateTweet)

const validateAttachment = (media, cardUri) => value => {
  const attachmentUrl = value
  const hasMedia = media && media.length

  if (hasMedia && attachmentUrl) {
    return 'Media and Attachment URL cannot be combined'
  }
  if (attachmentUrl && cardUri) {
    return 'Card URI and Attachment URL cannot be combined'
  }
}

const isInvalidCardUri = cardUri =>
  cardUri && !/(card:\/\/)([0-9]+)/g.test(cardUri)
const hasWhiteSpace = cardUri => cardUri && /[\s+]/g.test(cardUri)

const validateCardUri = (media, attachmentUrl) => value => {
  const cardUri = value
  const hasMedia = media && media.length

  if (cardUri && attachmentUrl) {
    return 'Card URI and Attachment URL cannot be combined'
  }
  if (hasMedia && cardUri) return 'Media and Card URI cannot be combined'
  if (isInvalidCardUri(value)) return 'Enter a valid cardUri'
  if (hasWhiteSpace(value)) return 'Remove all whitespace'
}

export {
  validateTweet,
  validateBlastTweet,
  validateDm,
  validateCardUri,
  validateAttachment
}



// WEBPACK FOOTER //
// ./src/pages/widgets/form/tweet-input/validation.js